export const eventFormConstants = {
    CHAPTER_EVENT_PROGRAMMING: 'Quick-Create Chapter Event',
    CHAPTER_ADMINISTRATOR_NAME: 'Chapter Manager Name *',
    CA_EMAIL: 'Chapter Manager Email *',
    BEST_TIME_CONTACT: 'Best time to contact *',
    TIME_ZONE: 'Time Zone *',
    CHAPTER_SPONS: 'Chapter Sponsor(s) *',
    LAUNCH_DATE: 'Desired Event Launch Date',
    TEMPLATES: 'YPO Chapter Event Template',
    CONFIG: 'Default Configuration Features',
    GUESTS: 'Guests',
    CHAPT_ONLY: 'Chapter Only',
    SESSIONS: 'Sessions',
    FEES: 'Fees',
    FLAT_FEE: 'Flat Fee Per Ticket',
    FEE_REGTYPE: 'Flat Fee Per Reg Type',
    EVENT_TITLE: 'Event Title *',
    EVENT_CHAMP: 'Event Champion(s) *',
    EVENT_DESC: 'Event Description',
    EVENT_CAPACITY: 'Event Capacity',
    WHEN: 'When',
    WHERE: 'Where',
    REG_DEAD: 'Registration Deadline',
    SDATE: 'Start Date and Time *',
    EDATE: 'End Date and Time *',
    LOC_NAME: 'Location (Venue Name)',
    STREET_ADD: 'Street Address',
    CITY: 'City, State/Province',
    COUNTRY: 'Country',
    LIFE_LEARN: 'Lifelong Learning Category  *',
    AUDIENCE: 'Audience *',
    OP_FEATURE: 'OPTIONAL EVENT FEATURES',
    SPEAKER_NAME: 'SPEAKER Resource Name',
    SPEAKER_TTILE: 'SPEAKER Title / Topic',
    SPEAKER_BIO: 'SPEAKER Bio / Details,',
    PRICE: 'Price To Display On Connect',
    CURRENCY: 'Currency',
    CANCEL_DETAIL: 'Cancellation Details',
    DRESS: 'What to wear (Dress Attire)',
    CREATE_NEW: 'CREATE NEW EVENT',
    EVENT_TYPE: 'Event Type  *',
    FILETYPES_SUPPORTED: [
        '.doc',
        '.DOC',
        '.docx',
        '.DOCX',
        '.pdf',
        '.PDF',
        '.gif',
        '.GIF',
        '.jpeg',
        '.JPEG',
        '.jpg',
        '.JPG',
        '.png',
        '.PNG',
    ],
    FILENAME_MAX_LIMIT: 250,
    FILE_NAME_LENGTH_EXCEEDED: 'Filename length exceeded max character limit(250)',
    FILE_NOT_SUPPORTED: 'Invalid file type : only [gif, doc, docx, png, jpg, jpeg, pdf] file types allowed',
    FILENAME_ALREADY_EXISTS: 'File name already exists',
    FILE_SIZE_EXCEEDED: 'Total file size for all attachments cannot exceed 100MB',
    ERROR_MESSAGE_TIMEOUT_SECONDS: '3000',
    ATTACHED_FILES_HEADER: 'Please attach relevant image and files',
    ATTACHED_FILES_LABEL: 'Event banner/flyer, Champion Profile, Speaker Profile',
    BROWSE: 'Browse',
    CANCEL: 'cancel',
    NOTE: 'Note: Additional currencies can be requested through Cvent when you set up a merchant account',
    DROP_HERE: 'Drop here or',
    INFO: {
        EVENT_INFO:
            'Please allow up to five business days for our team to create your event. More complex events (e.g., fees, sessions, open to networks or regions) will require more time.',
        REQUIRED: '*Required',
        THANK_YOU: 'Thank You',
        SUBMIT_INFO:
            'The Chapter Administrator Support Team will create your event and contact you with questions or confirmation.',
    },
    VALIDATION: {
        REQUIRED: 'Please provide all required information.',
        INVALID_EMAIL: 'Please enter a valid email address',
        INVALID_DATE: 'Invalid date, start date and time is later than end date and time.',
    },
    EVENT_SUB_CATEGORY: 'Event Sub-Category  *',
};

export const eventType = {
    VIRTUAL: 'Virtual',
    IN_PERSON: 'In-Person',
    HYBRID: 'Hybrid(Both)',
};
